import React, { lazy, Suspense } from 'react';
import { Redirect, Route as ReactRouterRoute, Switch } from 'react-router-dom';
import { INVITATION_PREFIX_PATH } from '../../configs/AppConfig';
import Loading from '../../components/shared-components/Loading';
import { withSentryRouting } from '@sentry/react';
import { useCommunityPrefixPath } from '../../hooks/Routing';

const Route = withSentryRouting(ReactRouterRoute);

const InvitationViews = () => {
  const appPrefixPath = useCommunityPrefixPath();
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <Route
          path={`${INVITATION_PREFIX_PATH}/:invitationId/claim/:token`}
          component={lazy(() => import(`views/invitation-views/claim`))}
        />
        <Redirect from={`${INVITATION_PREFIX_PATH}`} to={`${appPrefixPath}/feed`} />
      </Switch>
    </Suspense>
  );
};

export default InvitationViews;
